import { useTranslation } from 'react-i18next';
import { useGetEmailRule, useGetFullNameRule, useGetPhoneRule, useGetRequiredRule } from '@/hooks';
import { AdminFormFieldsNames } from '../helpers/types';

export const useAdminFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const nameRule = useGetFullNameRule({ t });
  const email = useGetEmailRule({ t });
  const phoneRule = useGetPhoneRule({ t });

  return {
    [AdminFormFieldsNames.EMAIL]: [requiredRule, email],
    [AdminFormFieldsNames.NAME]: [requiredRule, nameRule],
    [AdminFormFieldsNames.PHONE_NUMBER]: [requiredRule, phoneRule],
    [AdminFormFieldsNames.ROLE]: [requiredRule],
  };
};
